module.exports = __webpack_public_path__ + "static/media/profile-ico.9bec846d.png";